import React, { useEffect, useState } from "react";
import Editor from "../../../components/Editor";
import { Button } from "../../../components/ui/button";
import { Eye } from "lucide-react";
import PaymentAdviceTemplate from "../../ABATransactions/PaymentAdviceTemplate";
import { API, fileUpload } from "../../../config";

const PaymentAdvice = ({
  templateData,
  setLoading,
  fetchTemplateData,
  trustId,
}) => {
  let defaultText = `We would like to confirm that we have received the funds in the trust account on your behalf in line with your prior instructions. As instructed, we have deducted the professional fees, paid to suppliers and have processed the remaining balance into the nominated bank account.`;

  const [value, setValue] = useState(templateData ? templateData : defaultText);
  const [showView, setShowView] = useState();
  
  useEffect(() => {
    setValue(templateData ? templateData : defaultText);
  }, [defaultText, templateData]);

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("value", value);
      formData.append("type", "payment-advice");
      formData.append("_method", "put");
      const { data } = await fileUpload(
        `${API.TEMPLATE_UPADATE}/${trustId}`,
        formData
      );
      if (data) {
        fetchTemplateData();
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <Editor value={value} setValue={(data) => setValue(data)} />
      <div className="flex w-full items-center justify-between mt-4">
        <Button
          onClick={() => {
            toggleShowModal();
          }}
        >
          <span className="flex items-center gap-1">
            <Eye size={18} /> Preview
          </span>
        </Button>
        <Button
          onClick={() => {
            handleSave();
          }}
        >
          Save
        </Button>
      </div>
      {showView && (
        <PaymentAdviceTemplate
          showView={showView}
          setShowView={setShowView}
          popupType={"template"}
          value={value}
        />
      )}
    </>
  );
};

export default PaymentAdvice;
